import { render, staticRenderFns } from "./CustomerContact.vue?vue&type=template&id=ca7d933c&scoped=true&"
import script from "./CustomerContact.vue?vue&type=script&lang=js&"
export * from "./CustomerContact.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContact.vue?vue&type=style&index=0&id=ca7d933c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7d933c",
  null
  
)

export default component.exports